// 主人公が崩れたら、ボスは今振っている拍も打ち切って、すぐ致命へ移る (2026-10-12・配布版の既定)。
//
// ユーザーの答え (10-12・答えるページ):
//   選択 =「崩れは今どおり致命まで続ける。そのかわり、どのボスも崩れてから約1.8秒以内に致命が当たるようにする
//          (技の途中で崩れた時・覚醒王・固有のとどめの長い待ちを縮める)」
//   一言 =「技の途中でプレイヤーが体幹崩したら途中でもボスの致命攻撃に移行するようにしてほしい。
//          じゃないと理不尽なくらいに連撃を食らうこともあるので」
// 測った元 = docs/research/2026-10-12-stun-to-finisher-times.md。直した記録 = docs/research/2026-10-12-stun-finisher-cut.md。
//
// 作り (boss.ts の updateBossBase):
//   溜め (telegraph) = 前からの作りのまま、その場で致命の溜めへ切り替える。
//   ※ 10-12 夕 (F-1「早送りに見える」) から、戻りは早回しせず等速で bridgeMs だけ見せて、途中から致命の溜めへ入る (下の setStunCutLook)。
//     覚醒王は戻りを挟まずすぐ致命の溜め (後ろ跳びの屈み) へ (下の stunCutDirect)。以下の「早回し」は前の見え方 (DEV ?stunCutLook=warp) の説明。
//   当たり (active) = 振りの残り (当たった後の振り抜き) と戻りを同じ倍率で早回しして、bridgeMs で待機の絵まで戻す。
//     走り抜け・壁ぎわの突進・切り下がり・当たりの残りが長い突進だけは早回しせず、その場で戻りへ入る (走りを早回しすると瞬間移動に見える)。
//   連撃の間 (comboGap)・連の拍の間 (beatGap) = 次の段・次の拍を出さず、その技の戻りへ入って早回し。
//   戻り (recovery) = 戻りの残りを早回しして、bridgeMs で待機の絵まで戻す (絵は技の戻りのまま・1コマで跳ばない)。
//     早回し = ボスの時計 (stateElapsed) をこの倍率で進める。位置も絵も時計で決まるので、間を飛ばさずに速く戻る。
//     連撃を1段目で打ち切った時に出る戻りの絵は、その連撃の最後の段の戻り (前からの作りと同じ)。
//   戻りが終わったら、待機を通らずに致命の溜めへ入る (待機の1コマで別の一手が割り込まない)。
//   崩した一撃そのもの (当たった当たり) は hits.ts で先に当たっている (ボスが崩れを見るのは次のコマ)。
//   覚醒王の大暴れ (台本の技) は宙にいることがあるので、戻りへは入らず、その場から致命の後ろ跳びで床へ降りる (awoken_devour_pounce.ts)。
//
// 旧 (今の拍の当たりと戻りまでは出し切る) は DEV ?stunCut=0 だけ (URL を読むのは game.ts の DEV の箱の中・scripts/check_dev_leak.mjs に登録)。
//   旧では覚醒王の跳び噛みの後ろ跳びの長さ・介錯の組み変わりの順も前のまま。

// 構え直しの見え方 (2026-10-12・検収パック 10-12 F-1 の答え「早送りに見える」・配布版の既定)。
//   前 (10-12 の昼) = 戻りの残り (0.85〜1.5 秒) を 4〜15 倍で回して、bridgeMs で待機の絵まで戻していた = 早送りに見えた。
//   今 = 戻りの絵の並びを順に、絵1枚ずつ等速 (倍率 1) で少し (poseHoldMinMs〜poseHoldMaxMs) 見せて、次の絵の頭へ進む
//     (絵と絵の間の長い保ちだけを飛ばす・boss.ts cutPoseHoldMs)。最後の絵を見せたら致命の溜めへ。絵の動きは等速なので早送りに見えず、
//     絵の並びは普段の戻りと同じなので1コマの跳びも普段の戻りと同じ大きさ。初めに試した「戻りの途中から直接致命へ切る」は、
//     戻りの絵 → 致命の構えが1コマで大きく跳んだ (騎士の突き 兜 78px・介錯の据えの振り 207px) のでやめた。
//     振りの残り (当たった後の振り抜き) は前と同じく 2 倍まで (覚醒王は上限なし)。
//   前の見え方 (戻りの早回し) は DEV ?stunCutLook=warp だけ (URL を読むのは game.ts の DEV の箱の中・scripts/check_dev_leak.mjs に登録)。
let warpLook = false
/** URL の値から切り替える。'warp' = 前 (戻りを早回し)。それ以外 (指定なし) = 既定 (戻りは等速・途中から致命へ)。 */
export function setStunCutLook(value: string | null | undefined): boolean {
  warpLook = value === 'warp'
  return warpLook
}
/** 戻りを早回しする前の見え方か (DEV の比較だけ)。 */
export function stunCutWarpsRecovery(): boolean { return warpLook }

let on = true

/** URL の値から切り替える。'0' / 'off' = 旧 (今の拍を出し切る)。それ以外 (指定なし) は既定 (打ち切る)。 */
export function setStunCut(value: string | null | undefined): boolean {
  on = !(value === '0' || value === 'off')
  return on
}
export function stunCutOn(): boolean { return on }

export const STUN_CUT = {
  /** 打ち切った技の戻りを、待機の絵まで戻すのに使う長さ (ms・壁時計)。戻りの残りがこれより短ければ早回ししない。 */
  bridgeMs: 200,
  /** ボスごとの戻りの長さ。覚醒王は致命 (後ろ跳び＋見せの跳び2回＋本命) が近い時 1.55 秒あるので、戻りを短く (1.8 秒に収める)。 */
  bridgeMsByBoss: { 'crowned-king-awoken': 100 } as Readonly<Record<string, number>>,
  /** 当たり (振り) の残りがこれより長い技 (走り続ける突進) は早回しせず、その場で戻りへ入る (boss.ts stunCutStopsInPlace)。 */
  warpActiveMaxMs: 300,
  /** 振りの残りの早回しの上限 (stunCutActiveRateMax)。 */
  activeRateMax: 2,
  activeRateMaxByBoss: { 'crowned-king-awoken': Infinity } as Readonly<Record<string, number>>,
  /** 踏み込みがこれ以上長い突進も早回しせず、その場で戻りへ入る。 */
  stopLungePx: 200,
  /** 早回しの間 (振りの残り・戻り) に体が 1 コマで動ける上限 (px)。踏み込み・戻りの寄りを早回しで1コマに詰めると跳んで見えるので抑える。
   *  30 = 普段の踏み込みの1コマの最大 (待機・技の途中を測って 31.7px) と同じくらい。12 にすると介錯の据えの振りの踏み込みが絵に遅れて、両足が 72px 跳んだ。 */
  maxStepPx: 30,
  /** 宙で崩れを見て、跳び噛みの段取りが組めない致命 (壁を背にした覚醒王) が床へ降りる長さ (ms・溜めの頭から)。 */
  dropMs: 220,
  /** 打ち切った戻りの絵1枚を等速で見せる長さの下限・上限 (ms)。bridgeMs を戻りの絵の枚数で割った値をここに収める (boss.ts cutPoseHoldMs)。
   *  67 = 4 コマ (絵が替わったと分かる長さ)・120 = 致命の溜めの頭の止めと同じ。 */
  poseHoldMinMs: 67,
  poseHoldMaxMs: 120,
} as const

/** 構え直し (戻りを見せる間) を挟まず、今の姿から致命の溜めへすぐ入るボス (2026-10-12 夕・F-2)。
 *  覚醒王: 致命の頭が後ろ跳びの屈み (体を沈める絵) なので、それが構え直しの代わりになる。後ろ跳びを前の拍の速さへ戻した分
 *  (屈み・宙・着地で +180ms) をここで取り返す。宙にいる時は前からの作り (その場から致命・宙の絵から床へ降りる)。
 *  DEV ?awokenHopPace=fast (10-12 昼の速い拍) と ?stunCutLook=warp (前の早回し) の時は前のまま (戻りを挟む)。 */
const DIRECT_BY_BOSS: Readonly<Record<string, true>> = { 'crowned-king-awoken': true }
let directPaused = false
/** awoken_devour_pounce.ts の速い拍の比較 (DEV) が立っている間は、構え直しを挟む前の作りに戻す。 */
export function setStunCutDirectPaused(paused: boolean): void { directPaused = paused }
export function stunCutDirect(bossId: string): boolean {
  return on && !warpLook && !directPaused && !!DIRECT_BY_BOSS[bossId]
}

/** 振りの残り (当たった後の振り抜き) を早回しする倍率の上限。介錯の据えの振りを 8.5 倍で回すと、振りの中の絵の動きが
 *  1 コマに詰まって両足が 84px 跳んだ (普段 31px)。2 倍まで。覚醒王は噛みの振りが短く (絵の替わりが小さい)、
 *  致命が近い時 1.55 秒あって時間が足りないので上限なし (戻りと同じ倍率)。 */
export function stunCutActiveRateMax(bossId: string): number {
  return STUN_CUT.activeRateMaxByBoss[bossId] ?? STUN_CUT.activeRateMax
}

export function stunCutBridgeMs(bossId: string): number {
  return STUN_CUT.bridgeMsByBoss[bossId] ?? STUN_CUT.bridgeMs
}

/** 戻りの残り (ms) から、ボスの時計を進める倍率を決める (1 以上)。 */
export function stunCutRate(remainingMs: number, bossId = ''): number {
  return Math.max(1, remainingMs / stunCutBridgeMs(bossId))
}
